import React from 'react';
import './style/App.css';
// rutas
import Routes from './routes/routes';

const App = () => {
  return (
    < Routes />
  );
}

export default App;
